<app-vj-header></app-vj-header>
<!-- <app-vj-breadcrumb></app-vj-breadcrumb> -->
<div class="container-fluid px-3 mt-2">
  <router-outlet></router-outlet>

  
</div>

 <app-vj-footer></app-vj-footer>
